import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-phone',
    templateUrl: './phone.component.svg',
    styleUrls: ['./phone.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhoneComponent {}
